import { object, string } from '@gogame/schemas';

export const trackerRedirectSchema = object({
  affectedSecondaryDimension: string(),
  affectedDimension: string(),
});
